import gql from 'graphql-tag'

export const DOCUMENT_LAYOUT_DELETE_MUTATION = gql`
    mutation documentLayoutDelete(
        $id: ID!
    ) {
        documentLayoutDelete(
            id: $id
        ) {
            status
        }
    }
`
